const MainLayout = () => import(/* webpackChunkName: "layout", webpackPrefetch: true */"./MainLayout");
export { MainLayout };